// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ForgotForm = registerClientReference(
    function() { throw new Error("Attempted to call ForgotForm() from the server but ForgotForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/components/auth/ResetForm.tsx",
    "ForgotForm",
);
export const ResetForm = registerClientReference(
    function() { throw new Error("Attempted to call ResetForm() from the server but ResetForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/components/auth/ResetForm.tsx",
    "ResetForm",
);
